.card {
  padding: 12px 16px;
  border-radius: var(--radius);
  background: var(--white);
  border: 1px solid var(--gray-border);
  overflow: hidden;
}

.nameRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 10px;
  margin: -12px -16px 10px -16px; /* mirrors .card padding for full-bleed */
  padding: 12px 16px;
  background: var(--blue-light);
}

.name {
  font-size: 18px;
  font-weight: 700;
  color: var(--white);
}

.badges {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  color: var(--text);
  background: var(--white);
  border: none;
  border-radius: 999px;
  padding: 4px 8px;
  white-space: nowrap;
}

.badgeType {
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.5;
}

.section + .section {
  border-top: 1px solid var(--gray-border);
  padding-top: 8px;
  margin-top: 8px;
}

.section {
  margin-top: 8px;
}

.sectionHeader {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--gray-text);
  opacity: 0.6;
  margin-bottom: 6px;
}

.fields {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 20px;
}

.fieldBreak {
  flex-basis: 100%;
  height: 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.fieldHeader {
  display: flex;
  align-items: center;
  gap: 4px;
}

.fieldIcon {
  color: var(--gray-text);
  opacity: 0.5;
  flex-shrink: 0;
}

.fieldLabel {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--gray-text);
  opacity: 0.6;
}

.fieldValue {
  font-size: 13px;
  color: var(--text);
  font-weight: 500;
}
